import React from 'react'
import { useElementSize } from '@mote/helpers'
import type { AudioWaveformProps } from '../Audiowaveform'
import { AudioWaveformSkeleton, getWaveWidth } from '../Audiowaveform'
import {
  StyledWaveformScrubberSkeleton,
  WaveformScrubberTrack
} from './WaveformScrubber.styles'

const waveformData = [
  0, 0, 0.3, 0.16, 0, 0.68, 0.84, 0.82, 0.38, 0.2, 0.05, 0.47, 0.73, 1, 0.56,
  0.12, 0.16, 0.29, 0.28, 0.19, 0.06, 0.56, 0.72, 0, 0, 0.24, 0.3, 0.02, 0,
  0.14, 0.9, 0.34
]

export interface WaveformScrubberSkeletonProps {
  size: AudioWaveformProps['size']
}

export const WaveformScrubberSkeleton = (
  props: WaveformScrubberSkeletonProps
): JSX.Element => {
  const { ref, width } = useElementSize<HTMLDivElement>()
  const numberOfBars = Math.round(width / getWaveWidth(props.size))

  return (
    <StyledWaveformScrubberSkeleton ref={ref}>
      <WaveformScrubberTrack>
        <AudioWaveformSkeleton
          data={waveformData}
          numberOfBars={numberOfBars}
          width={`${width}px`}
          variant='normal'
          size={props.size}
        />
      </WaveformScrubberTrack>
    </StyledWaveformScrubberSkeleton>
  )
}
